import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { EM_AUTOMATION_SCRIPTS_SLICE_NAME } from './constants';
import {
	TEmAutomationAssignedScriptsRequest,
	TEmAutomationAssignedScriptsResponsePayload,
	TEmAutomationAssignScriptRequest,
	TEmAutomationAvailableScriptsResponsePayload,
	TEmAutomationRemoveScriptRequest,
	TEmAutomationScriptsStore,
} from './types';

const initialState: TEmAutomationScriptsStore = {
	availableScripts: null,
	availableScriptsLoading: false,
	assignedScripts: null,
	assignedScriptsLoading: false,
	assignScriptLoading: false,
	assignScriptSuccess: false,
	removeScriptLoading: false,
	removeScriptSuccess: false,
};

const emAutomationScripts = createSlice({
	name: EM_AUTOMATION_SCRIPTS_SLICE_NAME,
	initialState,
	reducers: {
		getAvailableScriptsRequest: (state: TEmAutomationScriptsStore) => {
			const s = state;
			s.availableScriptsLoading = true;
		},
		getAvailableScriptsSuccess: (
			state: TEmAutomationScriptsStore,
			action: PayloadAction<TEmAutomationAvailableScriptsResponsePayload>,
		) => {
			const s = state;
			s.availableScripts = action.payload;
			s.availableScriptsLoading = false;
		},
		getAvailableScriptsFailure: (state: TEmAutomationScriptsStore) => {
			const s = state;
			s.availableScripts = null;
			s.availableScriptsLoading = false;
		},

		getAssignedScriptsRequest: (
			state: TEmAutomationScriptsStore,
			_action: PayloadAction<TEmAutomationAssignedScriptsRequest>,
		) => {
			const s = state;
			s.assignedScriptsLoading = true;
		},
		getAssignedScriptsSuccess: (
			state: TEmAutomationScriptsStore,
			action: PayloadAction<TEmAutomationAssignedScriptsResponsePayload>,
		) => {
			const s = state;
			s.assignedScripts = action.payload;
			s.assignedScriptsLoading = false;
		},
		getAssignedScriptsFailure: (state: TEmAutomationScriptsStore) => {
			const s = state;
			s.assignedScripts = null;
			s.assignedScriptsLoading = false;
		},

		assignScriptRequest: (
			state: TEmAutomationScriptsStore,
			_action: PayloadAction<TEmAutomationAssignScriptRequest>,
		) => {
			const s = state;
			s.assignScriptLoading = true;
			s.assignScriptSuccess = false;
		},
		assignScriptSuccess: (state: TEmAutomationScriptsStore) => {
			const s = state;
			s.assignScriptLoading = false;
			s.assignScriptSuccess = true;
		},
		assignScriptFailure: (state: TEmAutomationScriptsStore) => {
			const s = state;
			s.assignScriptLoading = false;
			s.assignScriptSuccess = false;
		},

		removeScriptRequest: (
			state: TEmAutomationScriptsStore,
			_action: PayloadAction<TEmAutomationRemoveScriptRequest>,
		) => {
			const s = state;
			s.removeScriptLoading = true;
			s.removeScriptSuccess = false;
		},
		removeScriptSuccess: (state: TEmAutomationScriptsStore) => {
			const s = state;
			s.removeScriptLoading = false;
			s.removeScriptSuccess = true;
		},
		removeScriptFailure: (state: TEmAutomationScriptsStore) => {
			const s = state;
			s.removeScriptLoading = false;
			s.removeScriptSuccess = false;
		},
	},
});

export default emAutomationScripts.reducer;

export const {
	getAvailableScriptsRequest,
	getAvailableScriptsSuccess,
	getAvailableScriptsFailure,
	getAssignedScriptsRequest,
	getAssignedScriptsSuccess,
	getAssignedScriptsFailure,
	assignScriptRequest,
	assignScriptSuccess,
	assignScriptFailure,
	removeScriptRequest,
	removeScriptSuccess,
	removeScriptFailure,
} = emAutomationScripts.actions;
